/**
 * Capitalizes the first letter of a string.
 * @param string - The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalize = (string: string | number | null) => {
  if (!string) return null;

  const stringified = string?.toString();

  return stringified.charAt(0).toUpperCase() + stringified.slice(1);
};

